module.exports = __webpack_public_path__ + "static/fonts/icomoon.decdf1a.eot";


//////////////////
// WEBPACK FOOTER
// ./static/otherIcon/fonts/icomoon.eot?b7i6dh
// module id = iH8v
// module chunks = 71